import { Box } from "@mui/material"
import Blogs from "../../../blog"
import { ToggleCategory } from "../../../../components/blogs/toggleCategory"
import { useState } from "react";

const NoticiasBody = () => {

    const [selected, setSelected] = useState<string>("Notícia");

    return <Box>
        <ToggleCategory selected={selected} setSelected={setSelected}/>
        <Blogs selected={selected}/>
    </Box>
}
export default NoticiasBody